import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {path: '/register', component: () => import('@/views/register/index'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '常用功能', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/default'),
      meta: {title: '首页', icon: 'default',
      defaultOpened: true      }
    }
    ]
  },
  // ===== 新增：用户消息中心（登录后即可访问，不需要在侧边栏显示） =====
  {
    path: '/user',
    component: Layout,
    redirect: '/user/message',
    hidden: true, // 不在侧边栏显示
    children: [
      {
        path: 'message',
        name: 'MessageCenter',
        component: () => import('@/views/ums/user/MessageCenter'),
        meta: {title: '消息中心', icon: 'message'},
        hidden: true
      }
    ]
  }
]

export const asyncRouterMap = [
   // ===== 新增：常用功能菜单（路径为根路径，并受权限控制） =====
  {
    alwaysShow: true,
    path: '/common',                    // 空路径，作为根菜单
    component: Layout,
    redirect: '/common/addProduct', // 重定向到第一个子路由（可根据需要改为 '/home'）
    name: 'common',              // 添加 name 用于权限识别
    defaultOpened: true,
    meta: {
      title: '常用功能',
      icon: 'home',
      defaultOpened: true        // 默认展开
    },
    children: [
      {
      path: 'homeAdmin',
      name: 'homeAdmin',
      component: () => import('@/views/home/index'),
      meta: {title: '仪表盘', icon: 'dashboard'},
      defaultOpened: true
    },
      {
        path: 'addProduct',
        name: 'commonAddProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '发布新商品', icon: 'product-add'},
        defaultOpened: true        // 默认展开
      },
      {
        path: 'order',
        name: 'commonOrder',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单查询', icon: 'product-list'},
        defaultOpened: true        // 默认展开
      },
      {
        path: 'shop-info',
        name: 'shopInfo',
        component: () => import('@/views/merchant/shop/shopInfo'),
        meta: {title: '店铺信息', icon: 'merchant-edit'},
        defaultOpened: true        // 默认展开
      }
    ]
  },
  // ========== 新增常用功能菜单 ==========
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '商品列表', icon: 'product-list'}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', icon: 'product-add'}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品类目', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '产品类型', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      },
      {
        path: 'productReviewList',
        name: 'productReviewList',
        component: () => import('@/views/pms/productReview/productReviewList'),
        meta: {title: '商品审核列表'},
        hidden: true
      }

      // === 2026-10-08 商品批量处理 相关次级页面 ===
      ,{
        path: 'batchEditRecord',
        name: 'batchEditRecord',
        component: () => import('@/views/pms/product/batchEditRecord'),
        meta: { title: '批量修改记录'}
      }
      , {
        path: 'batchChange',
        name: 'batchChange',
        component: () => import('@/views/pms/product/batchChange'),
        meta: { title: '批量修改' }
      }
      , {
        path: 'batchGoodsStandardRecord',
        name: 'batchGoodsStandardRecord',
        component: () => import('@/views/pms/product/batchGoodsStandardRecord'),
        meta: { title: '标品/品牌/特殊类目品牌申请记录' }
      }
      , {
        path: 'batchSetProperty',
        name: 'batchSetProperty',
        component: () => import('@/views/pms/product/batchSetProperty'),
        meta: { title: '商品属性快捷设置' }
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: {title: '秒杀活动列表', icon: 'sms-flash'}
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: {title: '秒杀时间段列表'},
        hidden:true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: {title: '秒杀时间段选择'},
        hidden:true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {title: '秒杀商品列表'},
        hidden:true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: {title: '品牌推荐', icon: 'product-brand'}
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: {title: '新品推荐', icon: 'sms-new'}
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: {title: '人气推荐', icon: 'sms-hot'}
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '专题推荐', icon: 'sms-subject'}
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
       
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      },
      {
        path: 'prefrenceArea',
        name: 'selectHomePrefrenceArea',
        component: () => import('@/views/sms/prefrenceArea/index'),
        meta: {title: '商品优选管理'},
        hidden:true
      }
     ,
      {
        path: 'skuPromotion',
        name: 'selectHomeSkuPromotion',
        component: () => import('@/views/pms/productAttr/skuPromotion'),
        meta: {title: '商品SKU优惠管理'},
        hidden:true
      },
      {
        path: 'promotionBigsale',
        name: 'bigSaleClearance',
        component: () => import('@/views/pms/product/PromotionManage'),
        meta: {title: '商品大减价大清仓管理'},
        props: { activityType: 'BIG_SALE' },
        hidden:true
      }
      // ,
      // {
      //   path: 'promotionClearance',
      //   name: 'Clearance',
      //   component: () => import('@/views/pms/product/PromotionManage'),
      //   meta: {title: '商品大清仓'},
      //   props: { activityType: 'CLEARANCE' },
      //   hidden:true
      // }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '系统配置', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'memberLevel',
        name: 'selectmemberlevel',
        component: () => import('@/views/sms/memberlevel/list'),
        meta: {title: '会员等级管理'},
        hidden:true
      }
      ,
      {
        path: 'luckyDrawActivity',
        name: 'selectLuckyDrawActivity',
        component: () => import('@/views/lucky_draw/activity/list'),
        meta: {title: '抽奖活动管理'},
        hidden:true
      }
       ,
      {
        path: 'tags',
        name: 'tagManagement',
        component: () => import('@/views/pms/tag/TagManagement'),
        meta: {title: '标签管理'},
        hidden:true
      },
      {
        path: 'product-tagging',
        name: 'productTagging',
        component: () => import('@/views/pms/tag/ProductTagging'),
        meta: {title: '商品标签查询'},
        hidden:true
      },
      {
        path: 'adminAgent',
        name: 'adminAgent',
        component: () => import('@/views/agent/index'),
        meta: {title: '代理管理'},
        hidden:true
      },
      {
        path: 'addArea',
        name: 'addArea',
        component: () => import('@/views/pms/area/add'),
        meta: { title: '新增地区' },
        hidden:true
      },
      {
        path: 'updateArea',
        name: 'updateArea',
        component: () => import('@/views/pms/area/update'),
        meta: { title: '编辑地区' },
        hidden:true
      },
      {
        path: 'pmsArea',
        name: 'pmsArea', // name: 'areaList',
        component: () => import('@/views/pms/area/index'),
        meta: { title: '地区管理' },
        hidden:true
      },
      {
        path: 'adminConfig',
        name: 'adminConfig',
        component: () => import('@/views/config/index'),
        meta: { title: '系统配置' },
        hidden:true
      },
      {
        path: 'WorryFreeConfig',
        name: 'WorryFreeConfig',
        component: () => import('@/views/worryfree/WorryFreeConfig'),
        meta: { title: '无忧会员配置' },
        hidden:true
      },
      {
        path: 'adminWorryFree',
        name: 'adminWorryFree',
        component: () => import('@/views/worryfree/AdminWithdraw'),
        meta: { title: '提现管理' },
        hidden:true
      },
      {
        path: 'merchantRightsTemplate',
        name: 'merchantRightsTemplate',
        component: () => import('@/views/merchant/rightsTemplate/index'),
        meta: { title: '权益模板' },
        hidden:true
      },
      {
        path: 'merchantRights',
        name: 'merchantRights',
        component: () => import('@/views/merchant/rights/index'),
        meta: { title: '商家权益余额' },
        hidden:true
      },
      {
        path: 'merchantRecommendLog',
        name: 'merchantRecommendLog',
        component: () => import('@/views/merchant/recommend/index'),
        meta: { title: '商家推荐关系' },
        hidden:true
      },
      {
        path: 'advertiseSlotConfig',
        name: 'advertiseSlotConfig',
        component: () => import('@/views/sms/advertise/slotConfig/index'),
        meta: { title: '时段配置', icon: 'time' },
        hidden:true
      } ,
      {
        path: 'advertisePositionType',
        name: 'homeAdvertisePositionType',
        component: () => import('@/views/sms/advertise/AdvertisePositionManage'),
        meta: {title: '广告位置管理', icon: 'sms-ad'}
      },
      {
        path: 'memberList',
        name: 'memberList',
        component: () => import('@/views/ums/admin/member'),
        meta: {title: '小程序用户管理', icon: 'sms-ad'}
      },
      {
        path: 'invoiceList',
        name: 'invoiceList',
        component: () => import('@/views/oms/invoice/index'),
        meta: {title: '开票申请管理', icon: 'invoice-list'}
      },
       {
        path: 'message',
        name: 'MessageCenter',
        component: () => import('@/views/ums/user/MessageCenter'),
        meta: {title: '消息中心', icon: 'message'},
        hidden: true
      },
       {
        path: 'message',
        name: 'SysMessageCenter',
        component: () => import('@/views/ums/sys/messageManage'),
        meta: {title: '消息管理', icon: 'message'},
        hidden: true
      },// src/router/index.js
      {
        path: 'mediaReview',
        name: 'MediaReview',
        component: () => import('@/views/media/review/index.vue'),
        meta: { title: '媒体内容校验', icon: 'el-icon-picture-outline' },
        hidden: true
      }
    ]
  },
  {
    path:'/pmsUpload',
    component: Layout,
    redirect: '/pms/pmsUpload',
    name: 'pmsUpload',
    meta: {title: '商品上架', icon: 'ums'},
    children: [
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/pms/product/index'),
        meta: {title: '商品列表', icon: 'product-list'}
      }
    ]
  },
  {
    path:'/merchant',
    component: Layout,
    redirect: '/ums/merchant',
    name: 'merchant',
    meta: {title: '商家管理', icon: 'ums'},
    children: [
      {
        path: 'merchantList',
        name: 'merchantList',
        component: () => import('@/views/merchant/index'),
        meta: {title: '商家管理列表', icon: 'merchant-list'}
      },
      {
        path: 'merchantAdd',
        name: 'merchantAdd',
        component: () => import('@/views/merchant/add'),
        meta: {title: '添加商家', icon: 'merchant-add'}
      },
      {
        path: 'merchantEdit',
        name: 'merchantEdit',
        component: () => import('@/views/merchant/update'),
        meta: {title: '编辑商家', icon: 'merchant-edit'}
      },
      {
        path: 'merchantPackage',
        name: 'merchantPackage',
        component: () => import('@/views/merchant/package/index'),
        meta: {title: '商家套餐管理', icon: 'merchant-edit'}
      },
      {
        path: 'shop-info',
        name: 'shopInfo',
        component: () => import('@/views/merchant/shop/shopInfo'),
        meta: {title: '店铺信息', icon: 'merchant-edit'}
      }
    ]
  },
  {
    path:'/distribution',
    component: Layout,
    redirect: '/ums/distribution',
    name: 'distribution',
    meta: {title: '利润分配配置', icon: 'ums'},
    children: [
      {
        path: 'distributionList',
        name: 'distributionList',
        component: () => import('@/views/distribution/index'),
        meta: {title: '利润分配配置列表', icon: 'distribution-list', keepAlive: true}
      },
      {
        path: 'distributionAdd',
        name: 'distributionAdd',
        component: () => import('@/views/distribution/components/DistributionConfigForm'),
        meta: {title: '添加利润分配配置', icon: 'distribution-add'}
      },
      {
        path: 'distributionEdit',
        name: 'distributionEdit',
        component: () => import('@/views/distribution/components/DistributionConfigForm'),
        meta: {title: '编辑利润分配配置', icon: 'distribution-edit'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  mode: 'hash',
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js